import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'

import * as content from './content'

@ngCore.Component({
  imports: [
    ds.overlay.centered.Component,
    ds.layout.widget.Component,
    ds.loader.Component,
    ds.button.Component,
    content.Component,
  ],
  selector: 'atn-check-in-modal',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.summit.checkIn.Feature} */
  public readonly checkInFeature = ngCore.inject(state.summit.checkIn.Feature)
}
